import {
    ROUTE_ARTS,
    ROUTE_ARTS_CREATE, ROUTE_CAFE24_ART_LIST,
    ROUTE_CAFE24_DASHBOARD, ROUTE_CAFE24_ERROR, ROUTE_CAFE24_INIT, ROUTE_CAFE24_ORDER_LIST, ROUTE_CAFE24_PRODUCT_LIST,
    ROUTE_DASHBOARD,
    ROUTE_USERS,
    ROUTE_USERS_EDIT,
} from '@/router/routeNames';
import UserListView from '@/views/UserListView';
import UserEditView from '@/views/UserEditView';
import ArtListView from '@/views/ArtListView';
import Dashboard from '@/views/Dashboard';
import ArtCreateView from '@/views/ArtCreateView';
import Cafe24Layout from '@/views/cafe24/Cafe24Layout';
import Cafe24DashboardView from '@/views/cafe24/Cafe24DashboardView';
import Cafe24InitView from '@/views/cafe24/Cafe24InitView';
import {cafe24Init, checkAuth, checkCafe24Code, checkCafe24PartnerAuth} from '@/router/hooks';
import Cafe24ErrorView from '@/views/cafe24/Cafe24ErrorView';
import Cafe24ProductListView from '@/views/cafe24/Cafe24ProductListView';
import Cafe24ArtListView from '@/views/cafe24/Cafe24ArtListView';
import Cafe24OrderListView from '@/views/cafe24/Cafe24OrderListView';

export default [
    {
        path: '/',
        redirect: ROUTE_DASHBOARD,
    },
    {
        path: '/dashboard',
        name: ROUTE_DASHBOARD,
        component: Dashboard,
    },
    {
        path: '/users',
        name: ROUTE_USERS,
        component: UserListView,
        beforeEnter: checkAuth,
    },
    {
        path: '/users/edit',
        name: ROUTE_USERS_EDIT,
        component: UserEditView,
        beforeEnter: checkAuth,
    },
    {
        path: '/arts',
        name: ROUTE_ARTS,
        component: ArtListView,
        beforeEnter: checkAuth,
    },
    {
        path: '/arts/create',
        name: ROUTE_ARTS_CREATE,
        component: ArtCreateView,
        beforeEnter: checkAuth,
    },
    {
        path: '/cafe24',
        component: Cafe24Layout,
        children: [
            {
                path: '',
                name: ROUTE_CAFE24_DASHBOARD,
                component: Cafe24DashboardView,
                beforeEnter: checkCafe24Code,
            },
            {
                path: 'product',
                name: ROUTE_CAFE24_PRODUCT_LIST,
                component: Cafe24ProductListView,
                beforeEnter: checkCafe24PartnerAuth,
            },
            {
                path: 'art',
                name: ROUTE_CAFE24_ART_LIST,
                meta: {
                    isAdmin: true,
                },
                component: Cafe24ArtListView,
                beforeEnter: checkCafe24PartnerAuth,
            },
            {
                path: 'order',
                name: ROUTE_CAFE24_ORDER_LIST,
                meta: {
                    isAdmin: true,
                },
                component: Cafe24OrderListView,
                beforeEnter: checkCafe24PartnerAuth,
            },
            {
                path: 'init',
                name: ROUTE_CAFE24_INIT,
                component: Cafe24InitView,
                beforeEnter: cafe24Init,
            },
        ],
    },
    {
        path: '/cafe24/error',
        name: ROUTE_CAFE24_ERROR,
        component: Cafe24ErrorView,
    },
];